import { Table } from 'antd';
import React from 'react';
import { useLoaderData, useNavigate, useOutletContext } from 'react-router-dom';


const columns = [
  {
    title: 'Product',
    dataIndex: 'product',
    key: 'product',
    ellipsis: true,
    fixed: 'left',
    width: '200px',
    className: `whitespace-nowrap font-medium text-[#189aa0] dark:text-white`,
  },
  {
    title: 'Location',
    dataIndex: 'location',
    key: 'location',
    className: `whitespace-nowrap font-medium text-[#189aa0] dark:text-white`,
  },
  {
    title: 'Available Quantity',
    dataIndex: 'available_quantity',
    key: 'available_quantity',
    className: `whitespace-nowrap font-medium text-[#189aa0] dark:text-white`,
  },
  {
    title: 'Physical Quantity',
    dataIndex: 'quantity',
    key: 'quantity',
    className: `whitespace-nowrap font-medium text-[#189aa0] dark:text-white`,
  },
  {
    title: 'Reserved Quantity',
    dataIndex: 'reserved_quantity',
    key: 'reserved_quantity',
    className: `whitespace-nowrap font-medium text-[#189aa0] dark:text-white`,
  },
  {
    title: 'Reserved Value',
    dataIndex: 'reserved_value',
    key: 'reserved_value',
    className: `whitespace-nowrap font-medium text-[#189aa0] dark:text-white`,
  },
  {
    title: 'Sold Reserved Quantity',
    dataIndex: 'reserved_quantity_sold',
    key: 'reserved_quantity_sold',
    className: `whitespace-nowrap font-medium text-[#189aa0] dark:text-white`,
  },
  {
    title: 'Demand Sold',
    dataIndex: 'demand_sold_quantity',
    key: 'demand_sold_quantity',
    className: `whitespace-nowrap font-medium text-[#189aa0] dark:text-white`,
  },
  {
    title: 'Demand Quantity',
    dataIndex: 'demand_reserved_quantity',
    key: 'demand_reserved_quantity',
    className: `whitespace-nowrap font-medium text-[#189aa0] dark:text-white`,
  },
  {
    title: 'Demand Value',
    dataIndex: 'demand_reserved_value',
    key: 'demand_reserved_value',
    className: `whitespace-nowrap font-medium text-[#189aa0] dark:text-white`,
  },
  {
    title: 'Value (GHc)',
    dataIndex: 'value',
    key: 'value',
    className: `whitespace-nowrap font-medium text-[#189aa0] dark:text-white`,
  },
]

const AllStock = () => {
  const stock = useLoaderData();
  const navigate = useNavigate();
  const { CustomBreadcrumb } = useOutletContext();
  // console.log(locations)
  // const onRow = (record, rowIndex) => {
  //   return {
  //     onClick: () => navigate(`/inventory/locations/${record.seo}/current-stock`)
  //   };
  // }

  const groupByCity = (data) => {
    return data.reduce((acc, item) => {
        (acc[item.product] = acc[item.product] || []).push(item);
        return acc;
    }, {});
  };

  const groupedData = groupByCity(stock.data);

  // console.log(stock);
  return (
    <div>
      <div className='flex justify-between m-4'>
        <h3 className='font-bold'><CustomBreadcrumb /></h3>
      </div>
      <Table
        sticky
        // onRow={onRow}
        // rootClassName='hover:cursor-pointer'
        dataSource={Object.entries(groupedData).flatMap(([value, items]) => 
          [
              { key: value, product: `${value} (${items.length})`, isGroup: true, children: items }, // Group Row
               // Item Rows
          ]
      )}
        columns={columns}
        scroll={{ x: 1500 }}
        pagination={false}
      />
    </div>
  )
}

export default AllStock;